import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/home',
    name: 'home',
    meta: {
      title: '营养健康服务'
    },
    component: () => import('@/views/home')
  },
  {
    path: '/prescription/prescriptionPayment',
    name: 'prescriptionPayment',
    meta: {
      title: '处方订单'
    },
    component: () => import('@/views/prescription/prescriptionPayments')
  },
  {
    path: '/prescription/prescriptionPayments',
    name: 'prescriptionPayments',
    meta: {
      title: '处方订单[新]'
    },
    component: () => import('@/views/prescription/prescriptionPayments')
  },
  {
    path: '/prescription/invoice',
    name: 'invoice',
    meta: {
      title: '开具发票'
    },
    component: () => import('@/views/invoice/invoice')
  },
  {
    path:'/prescription/usage',
    name: 'usage',
    meta: {
      title: '用法用量'
    },
    component: () => import('@/views/prescription/prescriptionUsage')
  },
  {
    path: '/propagate/propagateList/:id',
    name: 'propagateList',
    meta: {
      title: '宣教医嘱'
    },
    component: () => import('@/views/propagate/propagateList')
  },
  {
    path: '/propagate/propagateDetails/:id',
    name: 'propagateDetails',
    meta: {
      title: '宣教详情'
    },
    component: () => import('@/views/propagate/propagateDetails')
  },
  {
    path: '/dietaryguidance/dietaryguidanceDetail/:id',
    name: 'dietaryguidance',
    meta: {
      title: '膳食指导方案'
    },
    component: () => import('@/views/dietaryguidance/dietaryguidanceDetail')
  },
  {
    path: '/nutrition/diet/guidance/:id',
    name: 'guidance',
    meta: {
      title: '膳食套餐'
    },
    component: () => import('@/views/guidance/guidance')
  },
  {
    path: '/nutrition/diet/guidanceDetails/:id',
    name: 'guidanceDetails',
    meta: {
      title: '套餐详情'
    },
    component: () => import('@/views/guidance/guidanceDetails')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to , from, next) => {
  // 动态添加浏览器title
  window.document.title = to.meta.title
  next();
})

export default router
